/* Creative page: cards and columns rise into place as they scroll into view */
(function () {
  var items = Array.prototype.slice.call(document.querySelectorAll('.cr-reveal, .mh-cr-reveal'));
  if (!items.length) return;
  var groups = new Map();
  items.forEach(function (el) {
    var p = el.parentElement, n = groups.get(p) || 0;
    el.style.setProperty('--i', n); groups.set(p, n + 1);
  });
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
  items.forEach(function (el) { io.observe(el); });
})();
